import { Dayjs } from 'dayjs';

import { LocalEvent } from 'src/Hooks/Queries/useFetchEvents';
import { EventDtoTypeEnum } from 'src/Services/API/generated';

export type PrintablePlanningView = 'month' | 'week' | 'stays';
export type PrintFormat = 'grid' | 'stays';

export interface PrintOptions {
  showReminders: boolean;
  showSchoolHolidays: boolean;
  showPublicHolidays: boolean;
  showHouseholdLegend: boolean;
}

export const DEFAULT_PRINT_OPTIONS: PrintOptions = {
  showReminders: false,
  showSchoolHolidays: true,
  showPublicHolidays: true,
  showHouseholdLegend: true,
};

export interface Props {
  events: LocalEvent[];
  startDate: Dayjs;
  endDate: Dayjs;
  view: PrintablePlanningView;
  assetName: string;
  exportUrl: string;
  dateRangeLabel: string;
  weekDayLabels: string[];
  eventTypeLabels: Record<EventDtoTypeEnum, string>;
  activeEventTypes: EventDtoTypeEnum[];
  printOptions: PrintOptions;
  todaySummary: string;
  printedOnLabel: string;
}
